import * as S from "./Content.style";

const Content = ({ children, ...props }) => {
  return <S.Content {...props}>{children}</S.Content>;
};

export default Content;
